import { mount } from 'svelte';
import App from './App.svelte';
import './app.css';
import { registerSW } from 'virtual:pwa-register';

const target = document.getElementById('app');
if (!target) {
  throw new Error('Mount target #app not found');
}

registerSW({ immediate: true });

const app = mount(App, { target });

export default app;
